import { render, staticRenderFns } from "./WalletStatus.vue?vue&type=template&id=803e5daa&scoped=true"
import script from "./WalletStatus.vue?vue&type=script&lang=js"
export * from "./WalletStatus.vue?vue&type=script&lang=js"
import style0 from "./WalletStatus.vue?vue&type=style&index=0&id=803e5daa&prod&lang=scss"
import style1 from "./WalletStatus.vue?vue&type=style&index=1&id=803e5daa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "803e5daa",
  null
  
)

export default component.exports